export default __webpack_public_path__ + "static/media/CEM-NVR.7df9ab50.webp";